import React from 'react';
import PropTypes from 'prop-types';
import { Tag as ConstellationTag } from '@zillow/constellation';
import IdVerifiedTag from '../../../../../../../components/IdVerifiedTag';
import TagType from '../../../../../../../constants/tagType';
import IncomeVerifiedByFinicityTag from '../../../../../../../components/IncomeVerifiedByFinicityTag';
import NotIdVerifiedTag from '../../../../../../../components/NotIdVerifiedTag';

const SELF_REPORTED_TEXT = 'Self-Reported';

export default function Tag({ tagType }) {
  switch (tagType) {
    case TagType.idVerified:
      return <IdVerifiedTag />;
    case TagType.selfReported:
      return (
        <ConstellationTag appearance="info" id="self-reported-tag">
          {SELF_REPORTED_TEXT}
        </ConstellationTag>
      );
    case TagType.incomeVerifiedByFinicity:
      return <IncomeVerifiedByFinicityTag />;
    case TagType.notIdVerified:
      return <NotIdVerifiedTag />;
    default:
      return null;
  }
}

Tag.propTypes = {
  tagType: PropTypes.string,
};
